export default "__VITE_ASSET__23203a15__"